// Single canonical rule for timeline consumers: deleted entries are excluded before rendering.
export const isDeletedTimelineEntry = (entry = {}) => {
  const status = String(
    entry?.status
    || entry?.sleepDetails?.status
    || entry?.incidentData?.status
    || ''
  ).trim().toLowerCase();

  return status === 'deleted';
};
